import axios from "axios";
import store from "../store";

const baseURL = store.getters.mainAppURL + "complaints/";
export const getOrderLatestComplaint = (orderId) => axios.get(baseURL + "get_order_complaint/" + orderId)

